<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <v-text-field v-model="queryForm.number" label="设备序列号/sim卡号" outlined dense clearable hide-details
          @keyup.enter="getdata()" />
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <v-text-field v-model="queryForm.vehicle_number" label="车牌号" outlined dense clearable hide-details
          @keyup.enter="getdata()" />
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <v-select v-model="queryForm.bind_state" :items="bind_states" label="操作类型" dense outlined clearable
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" hide-details>
        </v-select>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <a-space>
          <v-btn color="primary" tile style="color:#fff;" @click="getdata()">
            <v-icon small>mdi-magnify</v-icon> 查询
          </v-btn>
          <v-btn color="success" tile @click="showadd">
            <v-icon small>mdi-plus</v-icon> 新增GPS
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <a-tabs v-model="queryForm.state" size="small" @change="(v) => getdata()">
      <a-tab-pane key="全部" tab="全部"></a-tab-pane>
      <a-tab-pane key="在线" tab="在线"></a-tab-pane>
      <a-tab-pane key="离线" tab="离线"></a-tab-pane>
      <a-tab-pane key="已使用" tab="已使用"></a-tab-pane>
      <a-tab-pane key="未使用" tab="未使用"></a-tab-pane>
      <a-tab-pane key="异常" tab="异常"></a-tab-pane>
    </a-tabs>
    <v-card tile class="mt-2">
      <v-data-table dense :headers="headers" :items="list" :items-per-page="list.length" no-data-text="无数据" hide-default-footer
        disable-sort fixed-header :height="height">
        <template v-slot:item.index="{ index }">
          {{ index + 1 }}
        </template>
        <template v-slot:item.vehicle_unit="{ item }">
          <p v-if="item.own_type_name">{{ item.own_type_name }}</p>
          <p v-else>{{ item.vehicle_unit }}</p>
        </template>
        <template v-slot:item.state="{ item }">
          <v-chip v-if="item.state === 3" color="success" label small outlined>在线</v-chip>
          <v-chip v-else-if="item.state === 1 || item.state === 2" color="primary" label small outlined>上线</v-chip>
          <v-chip v-else-if="item.state === 4" color="orange" label small outlined>下线</v-chip>
          <v-chip v-else-if="item.state === 0" color="error" label small outlined>离线</v-chip>
          <v-chip v-else-if="item.state === -1" color="error" label small outlined>异常</v-chip>
          <v-chip v-else color="error" label small outlined>未使用</v-chip>
          <p v-if="item.state === 0" class="error--text">
            {{ item.disconnectedAt | dateFormat('YYYY-MM-DD HH:mm:ss') }}
          </p>
        </template>
        <template v-slot:item.create_time="{ item }">
          {{ item.create_time | dateFormat('YYYY-MM-DD HH:mm:ss') }}
        </template>
        <template v-slot:item.action="{ item }">
          <a-space>
            <v-btn v-if="item.editable" text tile small color="success" @click="showedit(item)">编辑</v-btn>
            <a-popconfirm v-if="item.editable" title="删除GPS设备" placement="left" ok-text="确定" cancel-text="取消"
              @confirm="remove(item._id)">
              <v-btn text tile small color="error">删除</v-btn>
            </a-popconfirm>
          </a-space>
          <v-btn v-if="username === 'root'" text tile small color="purple" @click="sync(item._id)">同步</v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="model" persistent max-width="400px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ modeltitle }}
            <v-icon @click="cancelsave">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete v-model="form.vehicleid" :items="vehicles"
                    :rules="form.bind_state === 1 ? [vrules.required] : []" dense outlined
                    :menu-props="{ bottom: true, offsetY: true }">
                    <template v-slot:label>
                      车牌号 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="form.vehicle_unit" label="车辆所属单位" outlined dense>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="form.serial_number" :rules="[vrules.required]" outlined dense>
                    <template v-slot:label>
                      sim卡号 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="form.sim_number" :rules="[vrules.required]" outlined dense>
                    <template v-slot:label>
                      设备序列号 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select v-model="form.bind_state" :items="bind_states" :rules="[vrules.required]" no-data-text="无"
                    dense outlined :menu-props="{ bottom: true, offsetY: true }" @change="changeBindState">
                    <template v-slot:label>
                      操作类型 <span class="red--text">*</span>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="form.remark" outlined rows="2" dense>
                    <template v-slot:label>
                      备注
                    </template>
                  </v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!valid" @click="save">确定</v-btn>
            <v-btn tile @click="cancelsave">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "VehicleGps",
  data() {
    return {
      queryForm: {
        number: "",
        vehicle_number: "",
        bind_state: null,
        state: '在线',
      },
      headers: [
        { text: "序号", value: "index", width: 80, align: "center" },
        { text: "车牌号", value: "vehicle_number", width: 120, align: "center" },
        { text: "车辆所属单位", value: "vehicle_unit", width: 120, align: "center" },
        { text: "sim卡号", value: "serial_number", width: 150, align: "center" },
        { text: "设备序列号", value: "sim_number", width: 120, align: "center" },
        { text: "状态", value: "state", width: 100, align: "center" },
        { text: "操作类型", value: "bind_text", width: 100, align: "center" },
        { text: "操作时间", value: "optime", width: 120, align: "center" },
        { text: "操作人", value: "opby", width: 100, align: "center" },
        { text: "备注", value: "remark", width: 120, align: "center" },
        { text: "操作", value: "action", width: 150, align: "center" },
      ],
      list: [],
      height: 600,
      bind_states: [
        { text: '绑定', value: '1' },
        { text: '解绑', value: '0' },
      ],
      valid: true,
      model: false,
      modeltitle: "",
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      form: {},
      vehicles: [],
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: {},
  watch: {
  },
  mounted() {
    this.height = window.innerHeight - 200;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 200;
    };
    this.list = [];
  },
  activated() {
    this.getdata();
  },
  methods: {
    getdata(action) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/gpsdevice/list", { ...this.queryForm, action }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.vehicles = res.data.vehicles;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showadd() {
      this.form = {
        _id: "",
        vehicleid: "",
        vehicle_unit: "",
        serial_number: "",
        sim_number: "",
        bind_state: null,
        remark: "",
      };
      this.modeltitle = "新增GPS设备";
      this.model = true;
    },
    showedit(item) {
      this.form = {
        _id: item._id,
        vehicleid: item.vehicleid,
        vehicle_unit: item.vehicle_unit,
        serial_number: item.serial_number,
        sim_number: item.sim_number,
        bind_state: item.bind_state,
        remark: item.remark,
      };
      this.modeltitle = "编辑GPS设备";
      this.model = true;
    },
    changeBindState(v) {
      if (v === '0') {
        this.form.vehicleid = null;
        this.form.vehicle_unit = "";
      }
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/gpsdevice/save", { dataForm: this.form }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.model = false;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsave() {
      this.$refs.form.resetValidation();
      this.model = false;
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/gpsdevice/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    sync(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/gpsdevice/sync", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
p {
  margin: 0;
}

/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}
</style>